(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/snow-animation/assets/prescript.js') >= 0) return;  svs.modules.push('/components/tb-ui/snow-animation/assets/prescript.js');
"use strict";


svs.tb_ui = svs.tb_ui || {};
svs.tb_ui.snow_animation = svs.tb_ui.snow_animation || {};

 })(window);